import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { Accept: "application/json" },
});


// Upload a club GOV document. Preferred path is direct browser -> R2 (presigned PUT) so
// file bytes never touch the backend. If the direct PUT is blocked (e.g. the R2 bucket CORS
// policy isn't configured yet) it transparently falls back to the through-backend upload,
// so uploads never break. Once R2 bucket CORS is set, the direct path activates automatically.
export async function uploadClubDocument(clubId, itemId, file) {
  let presign = null;
  let putOk = false;
  try {
    const contentType = file.type || "application/octet-stream";
    presign = (await api.post(`/clubs/${clubId}/documents/presign`, {
      item_id: itemId, file_name: file.name, content_type: contentType, size: file.size,
    })).data;
    const put = await fetch(presign.upload_url, {
      method: "PUT", headers: { "Content-Type": presign.content_type }, body: file,
    });
    putOk = put.ok;
  } catch (_) {
    putOk = false;
  }
  if (presign && putOk) {
    return (await api.post(`/clubs/${clubId}/documents/confirm`, {
      doc_id: presign.doc_id, item_id: itemId, file_name: file.name, key: presign.key, size: file.size,
    })).data;
  }
  // Fallback: through-backend multipart (server enforces the same validation).
  const fd = new FormData();
  fd.append("item_id", itemId);
  fd.append("file", file);
  return (await api.post(`/clubs/${clubId}/documents`, fd)).data;
}
